<agpr-take-over-panel
    [id]="id"
    class="agpr-clickOutsideExcluded"
    [header]="'Save Filter'"
    [showFooter]="true"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    (visibleChange)="closeDialog()"
    [width]="60"
>
    <div
        class="agpr-saveFilterPanel"
        role="radiogroup"
        [attr.aria-labelledby]="'Save Filter'"
    >
        <div class="agpr-saveFilterPanel-inputGroup">
            <agpr-radio
                [value]="saveFilterPanelStateEnum.new"
                [(ngModel)]="saveType"
                (ngModelChange)="clearErrors()"
                label="Common.filter.savedFilters.newSavedFilter.name"
                hiddenLabel="Common.filter.savedFilters.newSavedFilter.name"
                id="saveFilterPanel.newSaveFilter"
                class="agpr-saveFilterPanel-radio"
                name="saveState"
            ></agpr-radio>
            <agpr-text-input
                *ngIf="saveType === saveFilterPanelStateEnum.new"
                [id]="'saveFilterPanel_newStyleNameInput'"
                class="agpr-saveFilterPanel-newNameInput"
                [(ngModel)]="newFilterName"
                (ngModelChange)="clearErrors()"
                [placeholder]=" 'Common.filter.savedFilters.newSavedFilter.name.placeholder'"
                maxlength="64"
                [bottomMargin]="false"
            ></agpr-text-input>
            <div
                class="agpr-saveFilterPanel-error"
                *ngIf="showErrors"
            >
                <agpr-form-message
                    *ngIf="errors.duplicate"
                    [marginBottom]="0"
                >
                    {{  'Common.filter.savedFilters.newSavedFilter.name.duplicateError' | localize }}
                </agpr-form-message>
                <agpr-form-message
                    *ngIf="errors.invalidLength"
                    [marginBottom]="0"
                >
                    {{  'Common.filter.savedFilters.newSavedFilter.name.invalidLength' | localize }}
                </agpr-form-message>
                <agpr-form-message
                    *ngIf="errors.empty"
                    [marginBottom]="0"
                >
                    {{ 'RSSFeeds.name.errors.empty' | localize }}
                </agpr-form-message>
            </div>
        </div>

        <div class="agpr-saveFilterPanel-inputGroup">
            <agpr-radio
                [value]="saveFilterPanelStateEnum.update"
                [(ngModel)]="saveType"
                (ngModelChange)="clearErrors()"
                label="Common.filter.savedFilters.update.label"
                hiddenLabel="Common.filter.savedFilters.update.label"
                id="saveFilterPanel.updateFilter"
                class="agpr-saveFilterPanel-radio"
                name="saveState"
            ></agpr-radio>
            <agpr-dropdown
                *ngIf="saveType === saveFilterPanelStateEnum.update"
                id="SaveStylesDialog.updateDropdown"
                [placeholder]="'Common.filter.savedFilters.select'"
                [options]="filterOptions"
                ariaLabel="Common.filter.savedFilters.select"
                [(ngModel)]="selectedFilterOption"
                (ngModelChange)="clearErrors()"
            ></agpr-dropdown>
            <div
                class="agpr-saveFilterPanel-error"
                *ngIf="showErrors && errors.noFilterSelected"
            >
                <agpr-form-message [marginBottom]="0">
                    {{ 'Common.filter.savedFilters.update.required' | localize }}
                </agpr-form-message>
            </div>
        </div>
    </div>
    <div class="agpr-saveFilterPanel-chipContainer">
        <label class="agpr-saveFilterPanel-chipContainer-label"> Filters </label>
        <agpr-form-message  *ngIf="showErrors && errors.incompatibleRegionalFilter">
            {{ 'Common.filter.savedFilters.update.incompatibleRegionalFilter' | localize }}
        </agpr-form-message>
        <div class="agpr-saveFilterPanel-chipContainer-scrollPanel">
            <agpr-scroll-panel>
                <div class="activeFilter-container">
                    <ng-container *ngFor="let filter of flatFilters">
                        <ng-container
                            *ngIf="
                                filter.currentChips &&
                                filter.currentChips.length > 0
                            "
                        >
                            <div class="activeFilter-label">
                                {{ filter.label | localize }}
                            </div>
                            <label
                                *ngIf="filter.currentIncludeExclude && filter.showIncludeExclude"
                                class="activeFilter-subLabel"
                            >
                                {{ (filter.currentIncludeExclude === includeExclude.include ?
                                    'Common.filter.included' :
                                    'Common.filter.excluded') | localize }}
                            </label>
                            <ul
                                [id]="id + '_activeFilters'"
                                class="activeFilter-contents"
                                agprListKeyboardNavigation
                                listOrientation="horizontal"
                                [focusOnChild]="true"
                                [list]="filter.currentChips"
                                role="group"
                                [attr.aria-label]="filter.label | localize"
                            >
                                <ng-container *ngFor="let chip of filter.currentChips; let i = index">
                                    <div
                                        *ngIf="chip.labelArgs?.['firstInGroup'] && !chip.labelArgs?.['firstInFilter']"
                                        class="activeFilter-groupLabel"
                                    >
                                        {{ 'and' | localize }}
                                    </div>
                                    <li
                                        class="agpr-chip"
                                        [id]="id + '.chip_' + i"
                                    >
                                        <span
                                            class="agpr-chip-label"
                                            [pTooltip]="chip.tooltip ? (chip.tooltip | localize) : (chip.label | localize: chip.labelArgs)"
                                            tooltipPosition="top"
                                        >
                                            {{
                                                (chip.label | localize: chip.labelArgs) + (chip.suffix | localize)
                                            }}
                                        </span>
                                        <agpr-button
                                            [id]="id + '.chip_' + i + '.delete'"
                                            class="agpr-chip-button"
                                            [style]="buttonTypes.icon"
                                            icon="agpr-i-close"
                                            tooltip="Common.forms.chips.delete"
                                            tooltipPosition="top"
                                            [ariaLabel]="(chip.label | localize: chip.labelArgs) + ' ' + ('Common.forms.chips.delete' | localize)"
                                            (click)="removeChip(filter, chip)"
                                        ></agpr-button>
                                    </li>
                                </ng-container>
                            </ul>
                        </ng-container>
                    </ng-container>
                </div>
            </agpr-scroll-panel>
        </div>
    </div>
    <ng-template #takeOverFooterLeft class="agpr-saveFilterPanel-footer">
        <agpr-button
            [id]="id + '.cancelButton'"
            label="Core.button.cancel"
            (click)="closeDialog()"
            [style]="buttonTypes.secondary"
        ></agpr-button>
    </ng-template>
    <ng-template #takeOverFooterRight>
        <agpr-button
            [id]="id + '.applyButton'"
            label="save"
            (click)="save()"
            [style]="buttonTypes.primary"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>
